import { getStripePaywallRouter } from '@inkitt/contracts-common';
import { z } from 'zod';
import { c } from '../../contract';

export const webRouter = c.router(
  {
    stripe: getStripePaywallRouter(c),
    isUnlimitedUser: {
      summary: 'Checks if a user is a subscribed unlimited user',
      method: 'POST',
      path: '/is-unlimited-user',
      body: z.object({
        email: z.string().email(),
      }),
      responses: {
        200: z.object({
          isExistingUser: z.boolean(),
          isUnlimited: z.boolean(),
        }),
      },
    },
    updateIterableProfile: {
      summary: 'Updates Iterable profile',
      method: 'POST',
      path: '/update-iterable-profile',
      body: z.object({
        userId: z.string(),
        email: z.string().email(),
        installLocale: z.string(),
        source: z.string().optional(),
      }),
      responses: {
        200: z.object({
          message: z.string(),
        }),
      },
    },
  },
  { pathPrefix: '/web' },
);
